var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.25;}\r\n\t.st1{opacity:0.41;}\r\n\t.st2{fill:#53D0F7;}\r\n\t.st3{opacity:0.31;}\r\n\t.st4{opacity:0.58;fill:#FFA000;enable-background:new    ;}\r\n\t.st5{opacity:0.58;fill:#2F7DED;enable-background:new    ;}\r\n\t.st6{opacity:0.47;}\r\n\t.st7{opacity:0.81;}\r\n\t.st8{fill:#233863;}\r\n\t.st9{fill:#FFA000;}\r\n\t.st10{fill:#2F7DED;}\r\n\t.st11{opacity:0.69;}\r\n\t.st12{fill:#FFFFFF;}\r\n\t.st13{opacity:0.61;}\r\n\t.st14{fill:#374081;}\r\n\t.st15{fill:#FFBA94;}\r\n\t.st16{fill:#FB8E77;}\r\n\t.st17{opacity:0.46;fill:#FB8E77;enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M474.6,303.5c0.4-7.2,0.2-14.5-0.6-21.7c-3.8-33.8-21.2-65.6-46.7-88.1c-9.1-8-19.5-15.2-25.4-25.8 c-10-17.8-9.2-38.3-21.6-55.9C368,94.5,350,80.7,329.6,73.7c-60.7-21-145.7,13.2-138.1,86.4c0,0.3,0.1,0.6,0.1,1.1 c1,15.2-10.9,28-26.1,28.3c-56,1.3-104.2,44.5-114.6,99.2c-6.6,35.2,4.2,73.7,30,98.6c19.2,18.6,45,28.8,70.8,35.8 c51.7,14.1,106.1,17,159.4,11.6c49.9-5,102.5-19.4,134.8-57.8C463.2,356.5,473.1,330.3,474.6,303.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 440.6,
    cy: 67.1,
    rx: 19.7,
    ry: 19.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M408.3,46.2c0.7,3.7-1.7,7.3-5.5,8s-7.3-1.7-8-5.5c-0.7-3.7,1.7-7.3,5.5-8C404,40.1,407.6,42.5,408.3,46.2z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 154.7,
    cy: 84.9,
    rx: 9.2,
    ry: 9.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2283 -0.9736 0.9736 0.2283 -381.007 394.4841)",
    className: "st2",
    cx: 58.3,
    cy: 437.6,
    rx: 15.1,
    ry: 15.1
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 89.9,
    cy: 66.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31,294.8c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8S31,293.9,31,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M473,110.2c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8C472.2,108.4,473,109.2,473,110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M57.9,37.3c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8C57.1,35.5,57.9,36.3,57.9,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M476.6,229.2c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8C475.8,227.5,476.6,228.3,476.6,229.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M213.6,37.3c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8C212.8,35.5,213.6,36.3,213.6,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M337.2,43.9c-0.6,2.9-3.5,4.8-6.4,4.2c-2.9-0.6-4.8-3.5-4.2-6.4c0.6-2.9,3.5-4.8,6.4-4.2 C335.9,38.1,337.8,40.9,337.2,43.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.6,96.8C71.9,88,60.9,84.7,52,89.4c-8.8,4.7-18.3,19-13.5,27.8s18.8,1.9,28.8,2 C81.3,119.4,81.3,105.6,76.6,96.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M472.6,364.9c6.3-10,7.8-22.3,6.5-34c-1.3-11.6-4.9-23.8-9.8-34.4c-4.7-10-11.5-18.9-13.5-30.1 c-2.6-14.7,4.2-28.9,5.7-43.3c3.1-28.8-16.3-54.1-40.4-67.8c-19.6-11.1-42.5-15.3-65.1-15c-20.3,0.3-40.5,3.9-60.1,8.7 c-18.9,4.7-37.4,10.8-57.3,8.9c-16.5-1.6-31.4-8.5-46.7-13.6c-36.7-12.2-81.1-13.9-114.7,4.7c-21.5,11.9-36.6,31.3-43.3,52.1 c-4.9,15.2-6.3,32.8-2.8,48.2c4,17.3,11.5,32.6,9.5,50.9c-1.6,15-7.1,29.6-6.6,44.8C34.5,358,39.4,371,47,381.6 c0.5,0.7,1,1.4,1.6,2h402.6C459.6,379,467.5,373,472.6,364.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M420.9,354.9c1.4-11.1-1.9-21.4-1.5-32.2c0.8-20.7,19.9-35.1,26.5-53.7c8.4-23.6,8-50.1-2.2-73.1 c-4.9-11.1-12.1-21.4-21.9-28.5c-15.1-11-35-13.4-53.6-12c-27.8,2.1-57.1,13.6-85,10.5c-15.4-1.7-20.1-17.8-28.1-28.3 c-9-11.9-21.3-21.3-34.8-27.6c-25-11.5-54.9-12.6-80.4-2.2c-27.2,11.1-51,38.3-49.4,69.1c0.7,14.2,6.7,28.4,3.9,42.4 C91,236.7,77.2,252.7,67.3,267c-11,15.8-17.7,34.6-19,53.8c-1.5,21.8,3.9,44,15.3,62.6h347.8 C416.4,374.7,419.6,364.9,420.9,354.9z"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M447.7,387.8H52.3c-0.9,0-1.6-0.7-1.6-1.6l0,0c0-0.9,0.7-1.6,1.6-1.6h395.5c0.9,0,1.6,0.7,1.6,1.6l0,0 C449.3,387.1,448.6,387.8,447.7,387.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M385.8,292.9h-76.9c-3.1,0-5.6-2.5-5.6-5.6v-46.7c0-3.7,3-6.8,6.8-6.8h55.2c0.6,0,1,0.4,1,1s-0.4,1-1,1 h-55.2c-2.6,0-4.8,2.1-4.8,4.8v46.7c0,2,1.6,3.6,3.6,3.6h76.9c2,0,3.6-1.6,3.6-3.6v-45.4c0-3.3-2.7-6-6-6h-10.7 c-0.6,0-1-0.4-1-1s0.4-1,1-1h10.7c4.4,0,8,3.6,8,8v45.4C391.5,290.4,388.9,292.9,385.8,292.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M307,291.6c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.3-1,0.1-1.4l31.4-28c0.4-0.4,1-0.3,1.4,0.1 c0.4,0.4,0.3,1-0.1,1.4l-31.4,28C307.5,291.5,307.2,291.6,307,291.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M387.5,292.4c-0.2,0-0.5-0.1-0.7-0.3l-31.4-27.8c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l31.4,27.8 c0.4,0.4,0.5,1,0.1,1.4C388,292.2,387.8,292.4,387.5,292.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M347.4,269.6c-1,0-2.1-0.3-3-1l-39.8-29.2c-0.4-0.3-0.5-1-0.2-1.4c0.3-0.4,1-0.5,1.4-0.2l39.8,29.2 c1.1,0.8,2.5,0.8,3.6,0l38.9-28.4c0.4-0.3,1.1-0.2,1.4,0.2c0.3,0.4,0.2,1.1-0.2,1.4l-38.9,28.4 C349.5,269.3,348.4,269.6,347.4,269.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M386.5,227.7c0.8,0.6,1.9,0.6,2.8,0l33.1-24.1c-1.3-1.6-3.2-2.6-5.4-2.6h-59.3c-1.8,0-3.5,0.9-4.5,2.2 c0,0,0.1,0,0.1,0.1L386.5,227.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M390.5,229.3c-0.8,0.6-1.7,0.8-2.6,0.8c-0.9,0-1.8-0.3-2.6-0.9l-5.1-3.7l-25.5,22.7c0,0,0,0-0.1,0 c0.5,0.2,1.2,0.4,1.8,0.4h62.9c0.4,0,0.7,0,1-0.1L395,226L390.5,229.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M378.6,224.4l-26.5-19.5c-0.2,0.6-0.3,1.2-0.3,1.8v37.4c0,1.2,0.5,2.3,1.3,3.2c0.1-0.2,0.1-0.3,0.3-0.5 L378.6,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M422.1,247.4c0.1,0.1,0.1,0.1,0.1,0.2c1-0.8,1.7-2.1,1.7-3.5v-36.1c0-0.9-0.2-1.8-0.5-2.7l-26.8,19.5 L422.1,247.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M424.1,341.5h-52.2c-3.1,0-5.6-2.5-5.6-5.6v-30.3c0-3.7,3-6.8,6.8-6.8h48.7c4.4,0,8,3.6,8,8v29.1 C429.7,339,427.2,341.5,424.1,341.5z M373,300.8c-2.6,0-4.8,2.1-4.8,4.8v30.3c0,2,1.6,3.6,3.6,3.6h52.2c2,0,3.6-1.6,3.6-3.6 v-29.1c0-3.3-2.7-6-6-6H373z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.3,
    y: 328.6,
    transform: "matrix(0.7469 -0.6649 0.6649 0.7469 -122.8697 336.2957)",
    className: "st12",
    width: 30,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.3,
    y: 315.2,
    transform: "matrix(0.6633 -0.7483 0.7483 0.6633 -107.2228 421.9657)",
    className: "st12",
    width: 2,
    height: 29.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M398,324.8c-0.8,0-1.6-0.2-2.3-0.8l-28.4-20.8l1.2-1.6l28.4,20.8c0.7,0.5,1.5,0.5,2.2,0l29.4-21.4l1.2,1.6 l-29.4,21.4C399.6,324.6,398.8,324.8,398,324.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 423.6,
    cy: 201.2,
    r: 12.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M420.8,206h-1.4v-8.3l-1.4,0.9v-1.4l1.4-0.9h1.4V206z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M423.7,205.4c-0.5-0.5-0.7-1.2-0.7-2.1v-4.5c0-0.9,0.2-1.6,0.7-2.1c0.5-0.5,1.2-0.7,2.1-0.7 c0.9,0,1.6,0.2,2.1,0.7c0.5,0.5,0.7,1.2,0.7,2.1v4.5c0,0.9-0.2,1.6-0.7,2.1c-0.5,0.5-1.2,0.7-2.1,0.7 C424.9,206.1,424.2,205.9,423.7,205.4z M426.9,204.4c0.2-0.3,0.3-0.6,0.3-1.1v-4.5c0-0.5-0.1-0.8-0.3-1.1 c-0.2-0.3-0.6-0.4-1.1-0.4c-0.5,0-0.9,0.1-1.1,0.4c-0.2,0.3-0.3,0.6-0.3,1.1v4.5c0,0.5,0.1,0.8,0.3,1.1 c0.2,0.3,0.6,0.4,1.1,0.4S426.7,204.7,426.9,204.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M144.8,197.7c-0.7,0-1.4-0.3-1.9-0.8l-8.5-8.8c-0.6-0.6-1.4-0.9-2.2-0.9l-83.2-0.1 c-4.6,0-8.4-3.8-8.4-8.4v-31.5c0-4.6,3.8-8.4,8.4-8.4h88.7c5.3,0,9.5,4.3,9.5,9.5v46.8c0,1.1-0.6,2-1.6,2.4 C145.4,197.6,145.1,197.7,144.8,197.7z M49.1,140.8c-3.5,0-6.4,2.9-6.4,6.4v31.5c0,3.5,2.9,6.4,6.4,6.4l83.2,0.1 c1.4,0,2.7,0.6,3.6,1.5l8.5,8.8c0.2,0.3,0.5,0.2,0.6,0.1c0.1,0,0.4-0.2,0.4-0.5v-46.8c0-4.2-3.4-7.5-7.5-7.5L49.1,140.8 L49.1,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124,157.4h-21.3c-0.6,0-1-0.4-1-1s0.4-1,1-1H124c0.6,0,1,0.4,1,1S124.6,157.4,124,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.7,157.4H57.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h32.6c0.6,0,1,0.4,1,1S90.3,157.4,89.7,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124,165H70.3c-0.6,0-1-0.4-1-1s0.4-1,1-1H124c0.6,0,1,0.4,1,1C125,164.6,124.6,165,124,165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124,172.6H88.5c-0.6,0-1-0.4-1-1s0.4-1,1-1H124c0.6,0,1,0.4,1,1C125,172.2,124.6,172.6,124,172.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.3,143.9h-28.9c-0.9,0-1.8,0.4-2.4,1l-7.2,7.5c-0.8,0.9-2.3,0.3-2.3-0.9v-11.3v-28.4 c0-4,3.2-7.2,7.2-7.2h34.7c3.3,0,5.9,2.6,5.9,5.9v26.4C140.4,140.7,137.2,143.9,133.3,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.8,125.1c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5 C106.6,122.6,107.8,123.7,107.8,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.4,125.1c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5 C118.2,122.6,119.4,123.7,119.4,125.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 128.7,
    cy: 125.1,
    r: 2.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4481 -0.894 0.894 0.4481 -146.8526 220.6222)",
    className: "st10",
    cx: 105.3,
    cy: 229.2,
    rx: 31.9,
    ry: 31.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.3,246.7c-3.5,0-6.5-2.6-6.9-6.1l-0.1-1.1h14l-0.1,1.1C111.7,244.1,108.8,246.7,105.3,246.7z  M100.6,241.5c0.7,1.9,2.5,3.2,4.6,3.2c2.1,0,3.9-1.3,4.6-3.2H100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M117.6,234.9H92.9v-11.3c0-6.5,5.3-11.8,11.8-11.8h1c6.5,0,11.8,5.3,11.8,11.8L117.6,234.9L117.6,234.9 z M94.9,232.9h20.6v-9.3c0-5.4-4.4-9.8-9.8-9.8h-1c-5.4,0-9.8,4.4-9.8,9.8C94.9,223.6,94.9,232.9,94.9,232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116.6,241.5H93.9c-2.3,0-4.2-1.9-4.2-4.2V237c0-2.3,1.9-4.2,4.2-4.2h22.6c2.3,0,4.2,1.9,4.2,4.2v0.3 C120.7,239.6,118.9,241.5,116.6,241.5z M93.9,234.9c-1.2,0-2.2,1-2.2,2.2v0.3c0,1.2,1,2.2,2.2,2.2h22.6c1.2,0,2.2-1,2.2-2.2 V237c0-1.2-1-2.2-2.2-2.2H93.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 152.6,
    cy: 70.4,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M151.5,62.4h2.2v11.8h-2.2V62.4z M151.5,76h2.2v2.2h-2.2V76z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M422.6,115H317.7c-5.6,0-10.1,4.5-10.1,10.1v39.5v15.8c0,1.7,2,2.5,3.2,1.3l10-10.4c0.9-0.9,2.1-1.4,3.4-1.4 l98.4-0.1c4.8,0,8.7-3.9,8.7-8.7v-37.3C431.3,118.9,427.4,115,422.6,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M359.2,135.7H334c-0.6,0-1-0.4-1-1s0.4-1,1-1h25.2c0.6,0,1,0.4,1,1S359.8,135.7,359.2,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M413.1,135.7h-38.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h38.6c0.6,0,1,0.4,1,1S413.7,135.7,413.1,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M397.5,144.7H334c-0.6,0-1-0.4-1-1s0.4-1,1-1h63.5c0.6,0,1,0.4,1,1S398,144.7,397.5,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M376.1,153.6H334c-0.6,0-1-0.4-1-1s0.4-1,1-1h42.1c0.6,0,1,0.4,1,1S376.6,153.6,376.1,153.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M289.2,117.1h29.2c0.9,0,1.8,0.4,2.5,1.1l7.3,7.5c0.8,0.9,2.3,0.3,2.3-0.9v-11.4V84.6c0-4-3.3-7.3-7.3-7.3 H288c-3.3,0-6,2.7-6,6V110C282.1,113.9,285.3,117.1,289.2,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M315.1,98.1c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5 C316.2,95.6,315.1,96.7,315.1,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M303.4,98.1c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5 C304.5,95.6,303.4,96.7,303.4,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M291.4,98.1c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5 C292.5,95.6,291.4,96.7,291.4,98.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 427.1,
    cy: 122.1,
    rx: 15.5,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M428.8,129.4h-2.1v-12.9l-2.2,1.3v-2.2l2.2-1.4h2.1V129.4z"
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M292.5,347.6h-26.2c-0.6,0-1-0.4-1-1s0.4-1,1-1h26.2c0.6,0,1,0.4,1,1C293.5,347.2,293,347.6,292.5,347.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M348.5,347.6h-40.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h40.1c0.6,0,1,0.4,1,1C349.5,347.2,349,347.6,348.5,347.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M332.2,356.9h-65.9c-0.6,0-1-0.4-1-1s0.4-1,1-1h65.9c0.6,0,1,0.4,1,1C333.2,356.5,332.8,356.9,332.2,356.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M310,366.3h-43.7c-0.6,0-1-0.4-1-1s0.4-1,1-1H310c0.6,0,1,0.4,1,1S310.5,366.3,310,366.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.8,332.8H56.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h67.6c0.6,0,1,0.4,1,1S124.3,332.8,123.8,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.8,311.9H56.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h67.6c0.6,0,1,0.4,1,1S124.3,311.9,123.8,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.8,322.4H87.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h36.5c0.6,0,1,0.4,1,1S124.3,322.4,123.8,322.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.8,300.9H87.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h36.5c0.6,0,1,0.4,1,1S124.3,300.9,123.8,300.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.8,290.9H99.2c-0.6,0-1-0.4-1-1s0.4-1,1-1h24.6c0.6,0,1,0.4,1,1C124.8,290.4,124.3,290.9,123.8,290.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203.5,193.4c1,0.3,2,0.6,3.1,0.7c-0.9,2.9-1,5.6,0.1,8.1c3.9,9,21.1,10.2,38.4,2.7c3.3-1.5,6.4-3.1,9.2-5 c4,6.3,11.7,10.5,20.5,10.5c13,0,23.5-9.3,23.5-20.7c0-3-0.7-5.8-2-8.3c6.1-3.7,9.7-8.5,9.3-13.5c-0.3-4.3-3.6-8-8.6-10.6 c8.4-5.4,13.6-15.2,12.8-25.8c-1.2-15.1-14-26.4-29-25.9c-0.4-0.9-0.8-1.9-1.3-2.8c-2-3.9-4.5-7.4-7.5-10.4 c2.9-3.3,4.7-7.6,4.7-12.3c0-10.2-8.2-18.4-18.4-18.4c-10.1,0-18.3,8.2-18.4,18.3c-4,0.2-8.1,1-12,2.5c-7.4,2.7-13.5,7.3-18.1,13 c-13.4,1.3-28.7,23-16.4,39.4c0,0-0.1,0-0.1,0C163.8,148.1,168.5,182.2,203.5,193.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M189.4,311l2.1,3.5l4.5,7.3l3.9,62.4l118.4,0l0.6-76.4l27.6-3.4l4.8-0.6l-33.7-75.2 c-3.9-12-14-20.5-26-20.6l-47.8-0.4l0.4-0.6h-27.1c-25.5,0-46.2,26.1-46.2,58.3v1.7l0.6,0.3l17.5,10l-2.3,6.6 C183.5,292.9,184.5,303.1,189.4,311z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M277.8,278c-0.1-0.3,0.1-0.5,0.4-0.6c0.3-0.1,0.5,0.1,0.6,0.4l7.7,33.3l27.2-3.2c0.3,0,0.5,0.2,0.6,0.4 c0,0.3-0.2,0.5-0.4,0.6l-28,3.3L277.8,278z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M226.8,210.9v-3.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v3.3c0,15.6,12.7,28.2,28.2,28.2 s28.2-12.7,28.2-28.2v-3.3c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v3.3c0,16.4-13.3,29.7-29.7,29.7 C240.1,240.5,226.8,227.2,226.8,210.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M275.9,224.3c-0.3-0.2-0.4-0.7-0.2-1c2.6-3.8,4-8.3,4-13v-2.8c0-0.4,0.3-0.7,0.7-0.7 c0.4,0,0.7,0.3,0.7,0.7v2.8c0,4.9-1.5,9.7-4.2,13.8c-0.1,0.2-0.4,0.3-0.6,0.3C276.1,224.4,276,224.3,275.9,224.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M241.2,229.5c-0.3-0.2-0.4-0.7-0.1-1c0.2-0.3,0.7-0.4,1-0.1c4.1,3.3,9.1,5,14.4,5c5.3,0,10.3-1.7,14.4-5 c0.3-0.2,0.8-0.2,1,0.1c0.2,0.3,0.2,0.8-0.1,1c-4.4,3.5-9.7,5.4-15.3,5.4C250.8,234.9,245.5,233,241.2,229.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M235.1,222.4c-2.1-3.7-3.2-7.9-3.2-12.1v-2.8c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v2.8c0,4,1,8,3,11.4 c0.2,0.3,0.1,0.8-0.3,1c-0.1,0.1-0.2,0.1-0.4,0.1C235.4,222.8,235.2,222.7,235.1,222.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M186,409.5L186,409.5c1.3,1.2,3,1.4,4.4,0.6c-0.1,0.1-0.1,0.2-0.1,0.4l-0.3,0.4c-1.4,1.4-1.4,3.7,0.1,5.1 l0.1,0.1c1.4,1.4,3.7,1.4,5.1-0.1l0,0c0.1,0.8,0.4,1.6,1,2.3l0.1,0.1c1.4,1.4,3.7,1.5,5.1,0.1l1.2-1.2c0.1,0,0.2,0,0.3-0.1 c0,0,0.1,0,0.2,0c-0.3,1-0.1,2.2,0.6,3.1c1.2,1.4,3.2,1.5,4.6,0.3c0,0,28.7-19.7,37.9-29.3l88.3,0.2 c14-0.2,25.2-10.4,27.6-23.3c0.9-4.1,1-8.5,0-12.9l-15.5-51l-50.1,6.1l6.9,30.7l-83.8,20.8l0,0.1l-3.3,0.9 c-5,1.4-7.4,8-11.7,13.4L186,404.4C184.6,405.8,184.6,408.1,186,409.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M189.8,410.5c-0.2-0.2-0.2-0.5,0-0.7l11.1-11.4c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-11.1,11.4 c-0.1,0.1-0.2,0.1-0.4,0.1C190,410.6,189.9,410.6,189.8,410.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M195.7,415c-0.2-0.2-0.2-0.5,0-0.7l11.1-11.4c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-11.1,11.4 c-0.1,0.1-0.2,0.1-0.4,0.1C195.9,415.1,195.8,415,195.7,415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M202.7,417.3c-0.2-0.2-0.2-0.5,0-0.7l11.4-11c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-11.4,11 c-0.1,0.1-0.2,0.1-0.3,0.1C202.9,417.4,202.8,417.4,202.7,417.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M294.6,343.4c-0.1-0.3,0.1-0.5,0.3-0.6l25.8-8.3c0.3-0.1,0.5,0.1,0.6,0.3c0.1,0.3-0.1,0.5-0.3,0.6 l-25.8,8.3c-0.1,0-0.1,0-0.2,0C294.8,343.7,294.6,343.6,294.6,343.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M199.2,136.2l6.1,34.4l0,0c0,0,0,0,0,0l0.5,2.8c2.6,14.5,15.2,24.6,29.4,24.6l2.6,14.5 c1.9,10.5,11.9,17.5,22.4,15.6c10.5-1.9,17.5-11.9,15.6-22.4l-6.4-36.2c0.2-2.4,0-4.9-0.4-7.3l-0.7-4.1l2.8-0.5 c6.1-1.1,10.2-7,9.1-13.1l0-0.2c-1.1-6.1-7-10.2-13.1-9.1l-1.4,0.2c-5.7,3.1-12.9,2.6-17.9-2.1c-0.7-0.6-1.3-1.3-1.9-2.1 c-3.7-5-8.4-9.6-13.3-10.3C230.5,131.6,206.1,135.4,199.2,136.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M205.3,170.6l0.5,2.8c2.6,14.7,15.6,24.9,30.1,24.6l-0.6,0.3l2.8,16l24.3-27.7c5.5-6.5,8.1-15.4,6.5-24.4 l-0.7-4.1c-2.1,1.2-3.3,3.5-3.2,5.9c0.7,14.7-9.6,28.1-24.6,30.7l-0.6,0.1C223.7,197.6,208.2,186.8,205.3,170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M234.9,186.8c-0.1-0.1-2.4-2.2-5.1-0.8c-0.2,0.1-0.5,0-0.7-0.2c-0.1-0.2,0-0.5,0.2-0.7 c3.3-1.8,6.2,0.9,6.2,0.9c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.1-0.2,0.2-0.4,0.2C235.2,186.9,235,186.9,234.9,186.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M228.7,151.8c1-0.2,2,0.5,2.2,1.5s-0.5,2-1.5,2.2c-1,0.2-2-0.5-2.2-1.5C227,153,227.7,152,228.7,151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.7,155.8c1-0.2,2,0.5,2.2,1.5c0.2,1-0.5,2-1.5,2.2c-1,0.2-2-0.5-2.2-1.5 C205,156.9,205.6,155.9,206.7,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M218.6,166c-0.3-0.4-0.4-0.8-0.3-1.2l2.1-14.1c0-0.3,0.3-0.5,0.6-0.4c0.3,0,0.5,0.3,0.4,0.6l-2.1,14.1 c0,0.2,0,0.4,0.1,0.5c0.6,0.8,2.4,2.5,6.6,1.1c0.3-0.1,0.5,0.1,0.6,0.3c0.1,0.3-0.1,0.5-0.3,0.6c-1.2,0.4-2.3,0.6-3.2,0.6 C220.4,168.1,219.1,166.7,218.6,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M233.8,178l-4-7l14.7-8.5l0.3,0.5c2.8,4.8,1.1,10.9-3.7,13.7l-3.9,2.2C236,179.6,234.5,179.2,233.8,178z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M234.9,162.9c-6.4,0-11.7-5.2-11.7-11.7c0-3.1,1.2-6.1,3.4-8.3c2.2-2.2,5.1-3.4,8.2-3.4c0,0,0,0,0,0 c6.4,0,11.7,5.3,11.7,11.7l0,0C246.6,157.7,241.4,162.9,234.9,162.9C234.9,162.9,234.9,162.9,234.9,162.9z M244.6,151.2 c0-5.3-4.3-9.7-9.7-9.7c0,0,0,0,0,0c-2.6,0-5,1-6.8,2.8c-1.8,1.8-2.8,4.3-2.8,6.8c0,5.3,4.3,9.7,9.7,9.7c0,0,0,0,0,0 C240.3,160.9,244.6,156.6,244.6,151.2L244.6,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M208.4,168.1c-6.4,0-11.7-5.3-11.7-11.7c0-6.4,5.2-11.7,11.7-11.7c0,0,0,0,0,0c6.4,0,11.7,5.2,11.7,11.7 l0,0C220,162.8,214.8,168.1,208.4,168.1C208.4,168.1,208.4,168.1,208.4,168.1z M218,156.4c0-5.3-4.3-9.7-9.7-9.7c0,0,0,0,0,0 c-5.3,0-9.7,4.3-9.7,9.7c0,5.3,4.3,9.7,9.7,9.7c0,0,0,0,0,0C213.7,166.1,218,161.7,218,156.4L218,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M218.4,154.2c-0.1-0.5,0.3-1,0.9-1.1l4.2-0.4c0.6-0.1,1,0.3,1.1,0.9c0.1,0.5-0.3,1-0.9,1.1l-4.2,0.4 c0,0-0.1,0-0.1,0C218.8,155.1,218.4,154.7,218.4,154.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M236.7,133.8c-0.6-0.9-2.2-1.9-4.5-2c-2.3-0.1-4.1,0.7-4.8,1.5c-0.8,0.8-0.5,1.6,0,1.9 c0.6,0.3,1.4,0.3,2.2,0.3c0.8,0,1.6,0,2.3,0c0.7,0,1.5,0.1,2.3,0.2c0.8,0.1,1.6,0.2,2.2,0 C237.1,135.4,237.4,134.7,236.7,133.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M201.1,139.9c0.2-1,1.4-2.6,3.5-3.5c2.1-0.9,4-0.8,5-0.3c1,0.5,1.1,1.3,0.6,1.7 c-0.5,0.5-1.2,0.8-2,1.1c-0.7,0.3-1.5,0.6-2.1,0.9c-0.6,0.3-1.3,0.6-2,1c-0.7,0.3-1.4,0.7-2.1,0.8 C201.4,141.5,200.8,141,201.1,139.9z"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273,149.5l-4.5-1.2l1.9-7c0.1-0.3,0.3-0.4,0.6-0.4c0.3,0.1,0.4,0.3,0.4,0.6l-1.6,6l3.6,0.9 c0.3,0.1,0.4,0.3,0.4,0.6c-0.1,0.2-0.3,0.4-0.5,0.4C273.1,149.5,273,149.5,273,149.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M141.1,244.2v-53c0-2.7,2.2-4.9,4.9-4.9h27.6c2.7,0,4.9,2.2,4.9,4.9v53c0,2.7-2.2,4.9-4.9,4.9h-27.6 C143.2,249,141.1,246.8,141.1,244.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M136,321.1c2.3,1.3,5.2,2.4,8.9,3.2c11.6,2.8,27.2-1.9,38-6.3l8.6-3.5l-2.1-3.5c-4.9-8-5.9-18.2-2.7-27.2 l2.3-6.6l-17.5-10l-5.6,1l-0.9-4.6l-4.2-21.6c4.9-1.4,16.3-5.1,16.3-5.1c1.8-0.3,3-2,2.7-3.8c-0.2-1.2-1-2.1-2-2.5 c0.1-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.2l1.6-0.2c2-0.2,3.5-2.1,3.2-4.1c-0.1-0.9-0.5-1.7-1.2-2.3l0,0 c2-0.2,3.5-2,3.3-4l0,0c-0.2-2-2-3.5-4-3.4l-0.4,0c-0.1,0-0.3-0.1-0.4-0.1c1.5-0.6,2.5-2.1,2.3-3.7c-0.2-2-2-3.5-4-3.4 l-15.5,1.3l-10.3,0c-6.5,0-11.8-5.3-11.8-11.9v-3.4c0-1.9-1.5-3.5-3.5-3.5c-2,0-3.6,1.6-3.6,3.6v9.1c-0.6,0.7-1.1,1.4-1.7,2.1 c-5.9,7.4-8.7,16.9-7.7,26.3l0.7,6.7l-3.1,55.6C121.9,306.8,127.7,316.8,136,321.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M164.3,217.6c0-0.3,0.2-0.5,0.5-0.5l15.9-1.4c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5l-15.9,1.4 c0,0,0,0,0,0C164.5,218.1,164.3,217.9,164.3,217.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M163.9,225.1c0-0.3,0.2-0.5,0.5-0.5l15.9-1.4c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5l-15.9,1.4 c0,0,0,0,0,0C164.2,225.5,164,225.3,163.9,225.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M161.3,232.5c0-0.3,0.2-0.5,0.4-0.6l15.8-1.8c0.3,0,0.5,0.2,0.6,0.4c0,0.3-0.2,0.5-0.4,0.6l-15.8,1.8 c0,0,0,0-0.1,0C161.6,232.9,161.3,232.7,161.3,232.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M171.9,294.5l-7.9-33.6c-0.1-0.3,0.1-0.5,0.4-0.6c0.3-0.1,0.5,0.1,0.6,0.4l7.9,33.6 c0.1,0.3-0.1,0.5-0.4,0.6c0,0-0.1,0-0.1,0C172.1,294.9,171.9,294.8,171.9,294.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M170.7,267.4c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2l17.6,10l9.7-22.4c0.1-0.3,0.4-0.4,0.7-0.3 c0.3,0.1,0.4,0.4,0.3,0.7L189.3,278L170.7,267.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressImage);
export default __webpack_public_path__ + "static/media/address_image.94912dff1c216c2cf79a3dc64008d18b.svg";
export { ForwardRef as ReactComponent };